module.exports = __webpack_public_path__ + "static/media/group-member-unselect.43c9d4fb.svg";